var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.49997C1.94772 1.49997 1.5 1.94768 1.5 2.49997V11.5C1.5 12.0523 1.94772 12.5 2.5 12.5H11.5C12.0523 12.5 12.5 12.0523 12.5 11.5V6.99997V2.49997V1.49997H12.4982H11.4982H8.5V2.49997H10.7998L5.64969 7.65007L6.3568 8.35717L11.4982 3.21578V5.49997H12.4982V2.49997H12.4989V6.49997L11.5011 6.49997V11.5H2.5011V2.49995H7.4989V1.49997H7H2.5Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnExternalLink);
export default __webpack_public_path__ + "static/media/icn_external_link.95ef738db8e2924938dfb45a9c53abf5.svg";
export { ForwardRef as ReactComponent };